import FilterRow from './FilterRow';

/**
 * One filter kit on every viewport. The chip row (15c) was drawn at 390px but
 * nothing about it is phone-bound — boxes and sheets resolve from the same
 * tokens either way, and the old seven-control desktop row was the last
 * pre-token surface on the flagship pages. Desktop just centres the row at
 * content width; the sheets centre themselves (FilterSheet).
 */
function Filters({ noOnlineFilter, inPanel }: { noOnlineFilter?: boolean; inPanel?: boolean }) {
  return (
    <div className="w-full desktop:max-w-content desktop:mx-auto">
      <FilterRow inPanel={inPanel} />
    </div>
  );
}

export default Filters
